var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTechSupport = function SvgTechSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1482FF",
    stroke: "#1482FF",
    strokeWidth: 0.696,
    d: "M9.993 3.192c3.623 0 6.576 2.932 6.612 6.54l-.496.498h.686v5.24a.56.56 0 0 1-.554.554h-4.407l-.104.133a1.7 1.7 0 0 1-1.348.651 1.73 1.73 0 0 1-1.727-1.728c0-.946.813-1.726 1.727-1.726.918 0 1.673.717 1.722 1.622l.017.33h1.226v-4.528c0-.303.25-.554.554-.554h1.986v-.425a5.9 5.9 0 0 0-5.894-5.894c-3.25 0-5.894 2.642-5.888 5.888v.425H6.09c.303 0 .554.251.554.554v4.692c0 .303-.251.554-.554.554H3.744a.554.554 0 0 1-.553-.554v-5.24h.194v-.425c0-3.64 2.964-6.607 6.608-6.607Zm.39 10.869a1.01 1.01 0 0 0-1.015 1.014 1.014 1.014 0 1 0 1.014-1.014Zm-6.48 1.244h2.023v-4.368H3.904zm10.163 0h2.022v-4.368h-2.022z"
  })));
};
export default SvgTechSupport;